import React, { useState } from "react";
import './App.css'; 

const TWEET_LIMIT = 280;

function splitToThread(text, threadParts) {
  const cleaned = text.trim().replace(/\s+/g, " ");
  if (!cleaned) return [];
  const sentences = cleaned.match(/[^.!?]+[.!?]+["']?|[^.!?]+$/g) ?? [cleaned];
  const segments = [];
  let current = "";

  for (const sentence of sentences) {
    const candidate = current ? `${current} ${sentence.trim()}` : sentence.trim();
    if (candidate.length <= TWEET_LIMIT) {
      current = candidate;
    } else {
      if (current) segments.push(current.trim());
      current = sentence.trim();
    }
  }
  if (current) segments.push(current.trim());

  while (segments.length < threadParts) {
    let maxIdx = 0;
    for (let i = 1; i < segments.length; i++) {
      if (segments[i].length > segments[maxIdx].length) maxIdx = i;
    }
    const target = segments[maxIdx];
    const mid = Math.floor(target.length / 2);
    let splitAt = target.indexOf(" ", mid);
    if (splitAt === -1) splitAt = mid;
    segments.splice(maxIdx, 1, target.slice(0, splitAt).trim(), target.slice(splitAt).trim());
  }
  return segments.slice(0, threadParts);
}

export default function ThreadGenie() {
  const [article, setArticle] = useState("");
  const [thread, setThread] = useState([]);
  const [generating, setGenerating] = useState(false);
  const [threadLength, setThreadLength] = useState(6);
  const [copyStatus, setCopyStatus] = useState(null);

  const handleGenerate = () => {
    if (!article.trim()) return;
    setGenerating(true);
    setTimeout(() => {
      setThread(splitToThread(article, threadLength));
      setGenerating(false);
    }, 600);
  };

  const copyToClipboard = async (text, id) => {
    await navigator.clipboard.writeText(text);
    setCopyStatus(id);
    setTimeout(() => setCopyStatus(null), 2000);
  };

  return (
    <div className="app-shell">
      <div className="glow-blob-1" />
      <div className="glow-blob-2" />

      <header className="header">
        <div className="logo-mark">🪄</div>
        <div className="brand">
          <h1>ThreadGenie</h1>
          <p>Viral threads from long content</p>
        </div>
      </header>

      <div className="input-section">
        <div className="input-label">
          <span>Input Content</span>
          <span className="word-count">{article.trim() ? article.trim().split(/\s+/).length : 0} words</span>
        </div>
        <textarea
          value={article}
          onChange={(e) => setArticle(e.target.value)}
          placeholder="Paste blog post or article here..."
        />
        
        <div className="controls-area">
          <label>Thread Length: <strong>{threadLength} Tweets</strong></label>
          <input 
            type="range" min="3" max="10" 
            value={threadLength} 
            onChange={(e) => setThreadLength(parseInt(e.target.value))} 
            className="range-slider"
          />
        </div>

        <button className="btn-primary" onClick={handleGenerate} disabled={!article.trim() || generating}>
          {generating ? "Generating..." : "Generate Magic"}
        </button>
      </div>

      {thread.length > 0 && (
        <div className="output-container">
          <div className="thread-tools">
            <h2>Your Thread</h2>
            <button className="btn-ghost" onClick={() => copyToClipboard(thread.map((t, i) => `${i+1}/${thread.length} ${t}`).join("\n\n"), 'all')}>
              {copyStatus === 'all' ? "✓ Copied All" : "Copy Full Thread"}
            </button>
          </div>
          
          {thread.map((tweet, index) => (
            <div key={index} className="tweet-card">
              <div className="tweet-card-header">
                <span className="tweet-index">{index + 1}/{thread.length}</span>
                <span className="char-count">{tweet.length} / 280</span>
              </div>
              <p className="tweet-content">{tweet}</p>
              <button 
                className="copy-individual-btn"
                onClick={() => copyToClipboard(tweet, index)} 
              >
                {copyStatus === index ? "✓ Copied Clean" : "Copy Clean Tweet"}
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="income-card">
        <p>Support this student project & help me get a new tech upgrades!</p>
        <a href="https://ko-fi.com/achintha" target="_blank" rel="noreferrer" className="kofi-button">
          ☕ Support on Ko-fi
        </a>
      </div>

      <footer className="app-footer">ThreadGenie © 2026 · Achintha Sandaruwan</footer>
    </div>
  );
}